jQuery(function($){
	$(document).ready(function(){
		$('.designThumb').hover(function(e){
			e.preventDefault();
			if(!$(this).hasClass('active')){
				$this = $(this);
				$('#previewImage').fadeOut(200,function(){
					$('#previewImage').attr('src', $this.attr('href')).fadeIn(200);
				});
			}
		},function(e){
			e.preventDefault();
			if(!$(this).hasClass('active')){
				var thisDesign = $('.designThumb.active').length > 0 ? $('.designThumb.active').attr('href'):'';
				$('#previewImage').fadeOut(200,function(){
					$('#previewImage').attr('src',thisDesign).fadeIn(200);
				});
			}
		}).click(function(e){
			e.preventDefault();
			$('.errors').fadeOut();
			$this = $(this);
			if(!$this.hasClass('active')){
				$('.designThumb').removeClass('active');
				$this.addClass('active');
			}
			if($('#previewImage').attr('src') !=  $this.attr('href')){
				$('#previewImage').fadeOut(200,function(){
					$('#previewImage').attr('src', $this.attr('href')).fadeIn(200);
				});
			}
		});
		if(typeof(selectedDesign) != 'undefined' && selectedDesign > 0){
			$('.designThumb[data-id='+selectedDesign+']').click();
		}
		$('#designForm').submit(function(){
			if($(this).find('input[name=design_id]').val() == ""){
				$('.errors').html('Please Select a Design for your Instant Gift Certificate.').fadeIn();
				return false;
			}
		});
	});
	$('#design_next').click(function(e){
		e.preventDefault();
		$('input[name=design_id]').val($('.designThumb.active').data('id'));
		$('#designForm').submit();
	});
});






// WEBPACK FOOTER //
// ./resources/assets/js/design.js